<div class="cdr-legend-card vehicle-campus-legend" [class.collapsed]="!isExpanded">
  <div class="legend-header" (click)="toggleCollapse($event)">
    <div class="header-title-wrap">
      <span class="pulse-indicator"></span>
      <span class="header-title">Campus / Vehicles</span>
    </div>
    <div class="header-actions">
      <button class="legend-btn icon-btn collapse-btn" (click)="toggleCollapse($event)" title="Toggle campus list">
        <i class="fa-solid" [class.fa-chevron-down]="isExpanded" [class.fa-chevron-up]="!isExpanded"></i>
      </button>
    </div>
  </div>

  @if (isExpanded) {
    <div class="legend-body">
      @if (view$ | async; as view) {
        <ul class="region-list">
          @for (row of view.rows; track row.id) {
            <li
              class="region-item"
              [class.active]="view.selectedId === row.id"
              (click)="onCampusClick(row, $event)"
              [title]="'Show ' + row.label + ' authorised / unauthorised vehicles'"
            >
              <span class="color-dot" [style.background-color]="view.selectedId === row.id ? '#22c55e' : '#00F0FF'"></span>
              <span class="region-name">{{ row.label }}</span>
              <span class="tower-count">({{ row.total }})</span>
              <i class="fa-solid fa-location-crosshairs fly-icon"></i>
            </li>
            @if (view.selectedId === row.id) {
              <li class="campus-stats">
                <div>Authorised in {{ row.authorisedInside }} · out {{ row.authorisedOutside }}</div>
                <div>Unauthorised in {{ row.unauthorisedInside }} · out {{ row.unauthorisedOutside }}</div>
              </li>
            }
          }
        </ul>
        <div class="legend-footer" (click)="onOverviewClick($event)" title="Show all campuses">
          <span class="total-text">Auth {{ view.authorised }} · Unauth {{ view.unauthorised }}</span>
          <i class="fa-solid fa-earth-africa overview-icon"></i>
        </div>
      }
    </div>
  }
</div>
